import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { sliderConfig } from "../config/slider";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./Hero.css";

const Hero: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Automatischer Bildwechsel alle 5 Sekunden
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % sliderConfig.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const nextSlide = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrentSlide((prev) => (prev + 1) % sliderConfig.length);
  };

  const prevSlide = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrentSlide((prev) =>
      prev === 0 ? sliderConfig.length - 1 : prev - 1
    );
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <div className="hero">
      {sliderConfig.map((slide, index) => (
        <div
          key={slide.id}
          className="hero-slider"
          style={{
            backgroundImage: `url(${slide.src})`,
            opacity: currentSlide === index ? 1 : 0,
            zIndex: currentSlide === index ? 1 : 0,
          }}
        />
      ))}

      <div className="hero-overlay" />

      <button className="slider-btn prev" onClick={prevSlide} type="button">
        <FaChevronLeft />
      </button>
      <button className="slider-btn next" onClick={nextSlide} type="button">
        <FaChevronRight />
      </button>

      <div className="slider-dots">
        {sliderConfig.map((_, index) => (
          <button
            key={index}
            type="button"
            className={`slider-dot ${currentSlide === index ? "active" : ""}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>

      <div className="hero-content">
        <h1>{sliderConfig[currentSlide].title}</h1>
        <p>{sliderConfig[currentSlide].description}</p>
        <div className="hero-btns">
          <Link to="/kontakt" className="btn btn-primary">
            Kostenlos beraten lassen
          </Link>
          <Link to="/leistungen" className="btn btn-secondary">
            Unsere Leistungen
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Hero;
